import "./src/styles/global.css";
// gatsby-browser.js

export const onClientEntry = () => {
  // GTM ID anpassen
  const GTM_ID = "GTM-NDQL2HC4";

  // Cookie- oder LocalStorage-Zustimmung prüfen
  const hasConsent = localStorage.getItem("cookie_consent") === "true";

  if (!hasConsent) return;

  // Schutz gegen doppeltes Laden
  if (window.gtmDidInit) return;
  window.gtmDidInit = true;

  // GTM Data Layer anlegen
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  // Script einfügen
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  // Optional: noscript-iframe anhängen
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";

  const noscript = document.createElement("noscript");
  noscript.appendChild(iframe);
  document.body.appendChild(noscript);
};
